import React, { useState } from "react";
import "../../css/entry.css";
import "../../css/reports.css";
import { Box, Card, CardContent } from "@mui/material";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import EditPO from "./EditPO";
import EditMaterialData from "./EditMaterialData";
import EditBill from "./EditBill";
import EditBillPassing from "./EditBillPassing";
import EditCRN from "./EditCRN";
import EditPayment from "./EditPayment";

function EditData() {
  const [component, setComponent] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const menuoptions1 = [
    { value: "1", label: "Update PO Data" },
     { value: "2", label: "Update Received Material Data" },
     { value: "4", label: "Update Bill Entry Data" },
    // { value: "5", label: "Update Bill Passing/Funding Data" },
    // { value: "6", label: "Update CRN Entry" },
    // { value: "7", label: "Update Payment Entry" },
  ];

  const handleOptionChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Load component based on selection
    let loadedComponent = null;
    
    switch (value) {
      case "1":
        loadedComponent = <EditPO />;
        break;
      case "2":
        loadedComponent = <EditMaterialData />;
        break;
      case "4":
        loadedComponent = <EditBill />;
        break;
      case "5":
        loadedComponent = <EditBillPassing />;
        break;
      case "6":
        loadedComponent = <EditCRN />;
        break;
      case "7":
        loadedComponent = <EditPayment />;
        break;
      default:
        loadedComponent = null;
    }
    setComponent(loadedComponent);
  };

  return (
  <>
    <style>{`
      .edit-data-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        background: #f4f8fc;
        overflow-x: hidden;
      }

      .edit-data-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin: 0 auto;
        border-radius: 16px !important;
        border: 1px solid #dbe7f3;
        background: #ffffff !important;
        box-shadow: 0 6px 22px rgba(13, 71, 161, 0.10) !important;
        overflow: hidden;
      }

      .edit-data-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0.2px;

        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .edit-data-header::before {
        content: "✏️";
        font-size: 20px;
      }

      .edit-data-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 20px;
      }

      .edit-data-selector-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 16px;
        margin-bottom: 18px;
        background: #fbfdff;
        border: 1px solid #e0eaf5;
        border-radius: 12px;
      }

      .edit-data-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dce8f5;

        color: #0d47a1;
        font-size: 15px;
        font-weight: 700;
      }

      .edit-data-section-title::before {
        content: "";
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: linear-gradient(
          180deg,
          #0d47a1,
          #1976d2
        );
      }

      .edit-data-dropdown {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .edit-data-dropdown .MuiFormControl-root {
        width: 100%;
        max-width: 100%;
      }

      .edit-data-component {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        overflow-x: hidden;
      }

      .edit-data-component > * {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .edit-data-component .Formcard {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      @media (max-width: 650px) {
        .edit-data-page {
          padding: 8px;
        }

        .edit-data-card {
          border-radius: 12px !important;
        }

        .edit-data-header {
          padding: 13px 15px;
          font-size: 16px;
        }

        .edit-data-content {
          padding: 12px;
        }

        .edit-data-selector-section {
          padding: 12px;
          margin-bottom: 13px;
        }

        .edit-data-component {
          padding: 0 !important;
        }
      }

      @media (max-width: 380px) {
        .edit-data-page {
          padding: 5px;
        }

        .edit-data-content {
          padding: 9px;
        }

        .edit-data-selector-section {
          padding: 10px;
        }

        .edit-data-header {
          font-size: 15px;
        }
      }
    `}</style>

    <div className="edit-data-page">
      <Card className="edit-data-card">

        {/* Header */}
        <div className="edit-data-header">
          Mechanical Workshop NER, Gorakhpur
        </div>

        <CardContent className="edit-data-content">

          {/* Data Selection */}
          <div className="edit-data-selector-section">

            <div className="edit-data-section-title">
              Select Data to Update
            </div>

            <div className="edit-data-dropdown">
              <CustomDropdownMenu
                options={menuoptions1}
                selectedOption={selectedOption}
                handleOptionChange={handleOptionChange}
                menulabel="Select which Data you want to Update"
              />
            </div>

          </div>

          {/* Selected Component */}
          {component && (
            <div className="edit-data-component">
              {component}
            </div>
          )}

        </CardContent>
      </Card>
    </div>
  </>
);
}

export default EditData;
